import { render } from "./DocumentPdfPreviewModal.vue?vue&type=template&id=5898b0d8"
import script from "./DocumentPdfPreviewModal.vue?vue&type=script&lang=js"
export * from "./DocumentPdfPreviewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__